import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-archive",
  "use": "icon-nav-archive-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-nav-archive\">\r\n<path d=\"M11.2,99.5h32.5l8.7,19c3.8,7.5,11.4,12.5,18.8,12.5h58.8c7.5,0,15-5,18.8-12.6l8.8-19h31.2c2.5,0,5,1.3,7.5,2.5\r\n\tc2.5,2.5,3.8,5,3.8,8.8v52.9c0,5-2.5,11.3-6.2,15.1c-3.8,3.8-8.8,6.3-15,6.3H21.2c-5,0-11.2-2.5-15-6.3c-3.8-5-6.2-10.1-6.2-16.3\r\n\tv-51.6C0,104.4,5,99.4,11.2,99.5z\" />\r\n<path d=\"M168.7,90.6h-17.5l-3.8,15.1c-2.5,8.9-11.2,15.1-20,15.1H75c-10,0-18.8-7.6-20-16.4l-3.8-13.8H32.5V26.4\r\n\tc0-2.5,1.2-5,2.5-7.6c2.5-2.5,5-3.8,7.5-3.8h114.9c6.2,0,10,5,10,10.1L168.7,90.6L168.7,90.6z M86.2,70.5c-2.5,0-3.8,1.2-5,3.8\r\n\tc-1.2,2.5,0,3.8,1.2,5l17.5,20.2l18.8-20.2c1.3-1.2,1.3-3.8,1.3-5c-1.3-2.5-3.8-3.8-6.2-3.8h-7.5V34H93.8v36.5H86.2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/nav/nav-archive.svg
// module id = Bzmx
// module chunks = 13